<template>
  <loader-wrapper
    :loading="getLoading('Bid')"
    style="position: relative"
    class="load-wrapper-map-home"
  >
    <div v-if="bids.length === 0 && !getLoading('Bid')" class="error-block">
      <p>В настоящее время погрузки отсутствуют</p>
      <template v-if="isError && !loading">
        <p class="err-p"><b>Данные не загрузились</b></p>
      </template>
    </div>
    <yandex-map
      :settings="settings"
      :coords="center"
      :zoom.sync="zoom"
      :controls="controls"
      :cluster-options="clusterOptions"
      ymap-class="ymap-desktop vw"
      @map-was-initialized="mapLoaded"
      @actionend="onBalloonOpen"
      @balloonclose="handleCloseBallon"
    >
      <ymap-marker
        v-for="bid in bidsListMap"
        :key="bid.id"
        marker-type="placemark"
        :marker-id="bid.id"
        :coords="bid.coords"
        :icon="{ ...markerIcon }"
        :balloon="renderBid(bid)"
        cluster-name="cluster"
      />
    </yandex-map>
  </loader-wrapper>
</template>

<script>
import {
  MAP_CENTER,
  clusterBidsOptions,
  markerSandIcon,
  ymapSettings,
} from './constants'
import { isBidViewed } from '@/helpers/visibilityOnScroll'
import { mapGetters } from 'vuex'
import BidInfoMobile from '@/views/Home/Shipping/Item/BidInfoMobile'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import Vue from 'vue'

export default {
  name: 'BidsMapHome',
  components: { LoaderWrapper },
  props: {
    freights: {
      type: Object,
      default: () => {},
    },
    bids: {
      type: Array,
      default: () => [],
    },
    selectedCoord: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      zoom: 5,
      controls: ['zoomControl'],
      center: MAP_CENTER,
      settings: ymapSettings,
      markerIcon: markerSandIcon,
      clusterOptions: clusterBidsOptions,
      map: null,
      mapLink: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'bids/getLoading',
      isError: 'bids/isError',
    }),
    bidsListMap() {
      let arr = []

      this.bids.map(bid => {
        arr.push({
          ...bid,
          coords: [bid['loading_point'].lat, bid['loading_point'].lng],
        })
      })

      return arr
    },
  },

  watch: {
    selectedCoord: {
      immediate: true,
      deep: true,
      handler(val) {
        if (Object.keys(val).length !== 0) {
          this.makeCenter(val)
        }
      },
    },
  },
  mounted() {
    document.addEventListener('click', this.emitNext)
  },
  methods: {
    makeCenter(coord) {
      this.$nextTick(() => {
        this.mapLink.setCenter([coord.lat, coord.lng], 10, {
          checkZoomRange: true,
        })
      })
    },
    handleCloseBallon() {
      this.$emit('closeBallon')
    },
    mapLoaded(e) {
      this.mapLink = e
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
      this.setCenter()
    },
    setCenter() {
      if (this.bids.length && this.bids[0].coords) {
        this.center = this.bids[0].coords
      }
    },
    stopLoading() {
      this.loading = false
    },
    emitNext(e) {
      let bidId = Number(e.target.getAttribute('id'))
      let bid = this.bids.filter(item => item.id === bidId)

      if (bid.length > 0) {
        this.$emit('next', bid[0])
      }
    },
    renderBid(bid) {
      const propsData = { bid, freight: this.freights[bid.freight_id] }

      const comp = new Vue({
        ...BidInfoMobile,
        parent: this,
        propsData,
      }).$mount()

      return { body: comp.$el.outerHTML }
    },
    onBalloonOpen(e) {
      if (e?.originalEvent?.map?.balloon?.isOpen()) {
        isBidViewed(this, '.customBalloon')
      }
    },
  },
}
</script>

<style lang="sass">
.customBalloon
  z-index: 99999
  top: 300px
.error-block
  position: absolute
  display: flex
  justify-content: center
  flex-direction: column
  align-items: center
  z-index: 1000
  background-color: rgba(255, 255, 255, 0.8)
  top: 0
  left: 0
  bottom: 0
  right: 0
.load-wrapper-map-home
.ymap-desktop.vw
  height: calc(100vh - 200px)
  .btn-block
    display: flex
    justify-content: center
  [class*=balloon__tail]
    display: none
  [class*=balloon__layout]
    width: 430px
    @media screen and (max-width: 600px)
      width: 100vw
  [class*=balloon-pane]
    @media screen and (max-width: 600px)
      z-index: 999999!important
  [class*=balloon_to_top]
    top: -502px!important

  [class*=balloon-overlay]
    @media screen and (max-width: 600px)
      left: 56px!important
      top: 501px!important
  .calc-cluster-balloon
    font-family: 'Rubik', sans-serif
  .ballon_body
    border: none
    background: none
    width: 100%!important
    @media screen and (max-width: 600px)
      width: 99%!important
  .el-card
    font-family: 'Rubik', sans-serif !important
    line-height: 125%!important
    box-shadow: none
    width: 400px!important
    @media screen and (max-width: 375px)
      width: 88%!important
    @media screen and (min-width: 414px)
      width: 86%!important
    @media screen and (min-width: 600px)
      width: 360px!important
  .subscr-btn
    width: 50%!important
  [class*=balloon__content]
    font-family: 'Rubik', sans-serif
    width: 450px!important
    padding: 4px 7px 8px 8px
    @media screen and (max-width: 600px)
      width: 97vw!important
      padding: 4px 7px 8px 6px
      margin-right: 0
  [class*=balloon__content] > *
    margin-top: 28px
    width: 100%!important
  [class*="default-cluster"] > *
    color: #6D7996
    position: absolute
    top: 0
    left: 38px
    font-family: Rubik, sans-serif
    font-weight: 900
    font-size: 15px
</style>
